<div id="wrap">
  <div class="preadesao">
    <h1>Reenviar Email de Validação</h1>
    <p>Confirme os dados abaixo para reenviar o link de validação</p>
    <div class="box adesao">
      <form [formGroup]="form">

        <!-- AGUARDANDO -->
        @if (!concluido) {
          <div>
            <div class="form-group full-width">
              <input type="text" formControlName="cpf" [(ngModel)]="cpf" mask="000.000.000-00" placeholder="CPF" />
              <span>Somente números</span>
            </div>
            <div class="form-group full-width">
              <input type="email" formControlName="email" placeholder="Email" />
              @if (!this.form.get('email').valid) {
                <div>
                  @if (this.form.get('email').dirty) {
                    <div>
                      <small class="text-danger">
                        Email Inválido
                      </small>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="text-danger text-center full-width erro-servidor" [ngStyle]="{'visibility': msgErro==null ? 'hidden' : 'visible' }">
              {{msgErro}}
            </div>
            <button type="submit" class="btn_verde" [disabled]="!form.valid || loading" (click)="reenviar()">
              ENVIAR  @if (loading) {
              <i class="fas fa-spinner fa-spin"></i>
            }
          </button>
        </div>
      }

      @if (concluido) {
        <div>
          <p>Digite o token que você recebeu no e-mail para concluir.</p>
          <div class="box adesao">
            <input name="token" placeholder="Código" [(ngModel)]="token" [ngModelOptions]="{standalone: true}" [disabled]="loading" maxlength="10" />
          </div>
          <br />
          <div style="display: flex; justify-content: center; align-items: center;">
            <button (click)="validarToken()" class="btn_verde" [disabled]="loading">
              Concluir @if (loading) {
              <i class="fas fa-spinner fa-spin"></i>
            }
          </button>
        </div>
      </div>
    }

  </form>
</div>
</div>
</div>
